import React from "react";
import AnimatedButton from "../Rounded/index";

function Button({ name, className, effect }) {
  return (
    <div>
      <AnimatedButton className={`${className}`} effect={`${effect}`}>
        <p className="relative z-10 transition-colors duration-100">
          {name}
        </p>
      </AnimatedButton>
    </div>
  );
}

export default Button;
